export default __webpack_public_path__ + "static/media/calculator.3ab81f0c.png";